import block from 'bem-cn-lite';
import React from 'react';
import SVG from 'react-inlinesvg';
import {getDataUrl} from 'utils/dataUrls';

import './index.scss';

const b = block('shares');

interface ILinks {
  [key: string]: string;
}

interface SharesProps {
  customUrl: string;
  className?: string;
}

const Shares: React.FC<SharesProps> = ({className, customUrl}) => {
  const socialNames = ['vk', 'facebook', 'odnoklassniki', 'twitter', 'telegram'];

  const links: ILinks = {
    vk: `https://vk.com/share.php?url=${customUrl}`,
    telegram: `https://telegram.me/share/url?url=${customUrl}`,
    twitter: `https://twitter.com/intent/tweet?url=${customUrl}`,
    odnoklassniki: `https://connect.ok.ru/offer?url=${customUrl}`,
    facebook: `https://www.facebook.com/sharer.php?&u=${customUrl}`,
  };

  return (
    <div className={b(null, className)}>
      {socialNames.map(socialName => (
        <a
          href={links[socialName]}
          className={b('link')}
          target={'_blank'}
          rel={'noopener noreferrer'}
          key={socialName}
        >
          <SVG src={getDataUrl(`./assets/share-icons/${socialName}-1.svg`)} className={b('icon')} />
        </a>
      ))}
    </div>
  );
};

export default Shares;
